import { LOCATION_CHANGE } from 'typed/utils/redux';
import { NetworkActionPrefix, ActionType, UserEngagementEventType } from 'utils/constants';
import { UserEngagementActionApi } from 'for-straction-service-api';
import appID from 'api/appID';

function sendUserEngagementEvent(eventType) {
    let userEngagementApi = new UserEngagementActionApi();
    userEngagementApi.userEngagementActionSendSimpleEventGet(appID, eventType, (err) => {
        // todo: no reason to show any error, if this request fails, but would be good to send report to bug tracker / notify developers
    });
}


const userEngagementEventHandler = store => next => action => {
    if (action.type === LOCATION_CHANGE && action.payload.pathname.indexOf('/scorecards/dashboards') === 0) {
        //sendUserEngagementEvent(UserEngagementEventType.VISITED_DASHBOARD_PAGE);
        // disable this now, will be replaced by 
    }
    return next(action);
};

export default userEngagementEventHandler;